var PaginationButtonsEnum;
(function (PaginationButtonsEnum) {
    PaginationButtonsEnum["PREVIOUS"] = "previous";
    PaginationButtonsEnum["NEXT"] = "next";
    PaginationButtonsEnum["ELLIPSIS"] = "...";
})(PaginationButtonsEnum || (PaginationButtonsEnum = {}));

export { PaginationButtonsEnum };
